import { Button, Col, Empty, Flex, Row } from 'antd';
import { useUIDispatchContext } from 'providers/UI';
import { FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PERMISSION_ACTIONS, PERMISSION_ROUTES } from 'constants/permissions';

import { useDoctorProfile } from 'pages/DoctorProfile/DoctorProfileContext';
import { OrganizationResult, Private } from 'components/shared';
import { PlanItem } from 'pages/DoctorProfile/components';
import { useSearchParams } from 'react-router-dom';

const Plans: FC = () => {
  // translations
  const { t } = useTranslation();
  // ui
  const { toggleModal } = useUIDispatchContext();
  const [searchParams] = useSearchParams();

  const lang = useMemo(() => searchParams.get('lang'), [searchParams]);

  const { profile } = useDoctorProfile();
  const plans = profile?.plans || [];

  const results = plans.filter(i => i.lang === (lang || 'en'));

  return (
    <OrganizationResult>
      {results.length ? (
        <Row gutter={[16, 16]} justify="start" wrap>
          {results.map(item => (
            <Col sm={12} key={`plan-item-${item.id}`}>
              <PlanItem
                id={item.id}
                name={item.name}
                type={item.type}
                duration={item.duration}
                description={item.description}
                price={item.price}
                features={item.features}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Row justify="center">
          <Empty />
        </Row>
      )}
      <Private
        route={PERMISSION_ROUTES.plan}
        action={PERMISSION_ACTIONS.create}
      >
        <Flex justify="flex-end" style={{ paddingTop: 24 }}>
          <Button
            type="primary"
            size="large"
            onClick={() => toggleModal('plans', true)}
          >
            {t('doctor_profile.add_plan')}
          </Button>
        </Flex>
      </Private>
    </OrganizationResult>
  );
};

export default memo(Plans);
